module.exports = __webpack_public_path__ + "static/assets/4580734804efd188ef52ee0316b92550.svg";